import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bitwarden = defineConnector({
  identifier: "bitwarden",
  name: "Bitwarden",
  tagLine: "Open-source password management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.bitwarden\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://identity.bitwarden.com/connect/token",
        method: "POST",
        formBody: {
          grant_type: "client_credentials",
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
          scope: "api",
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Bitwarden web vault](https://vault.bitwarden.com), go to **Settings → Security → Keys** and view your API key. You will need your **client_id** and **client_secret**.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.bitwarden.com/accounts/profile",
  },
});
